import { eBranches } from "../../dependencies";
import { CardType } from "../../data";
import { getAmericanFootballAdditionalData } from "./getAmericanFootballAdditionalData";
//To be extended for other sports with additional data
export const getGameStateAdditionalData = (details) => {
    return !details.isDesktop
        && details.event.cardType === CardType.American
        && parseInt(details.event.sportId) === eBranches.Football
        ? getAmericanFootballAdditionalData(details.event.score.additionalScores, details.event.participants, details.dict)
        : undefined;
};
//# sourceMappingURL=getGameStateAdditionalData.js.map